export default __webpack_public_path__ + "static/media/ruler.61533e03.webp";